const PACKAGE_FORM_SELECTOR = 'form[data-package-form="true"]'
const FILE_INPUT_SELECTOR = 'input[type="file"][name="package[hero_image]"]'
const DEFAULT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024

function parseMaxFileSize(form) {
  const raw = form.dataset.maxFileSizeBytes
  const parsed = Number.parseInt(raw || '', 10)

  if (Number.isNaN(parsed) || parsed <= 0) return DEFAULT_MAX_FILE_SIZE_BYTES

  return parsed
}

function formatSize(bytes) {
  const mb = bytes / (1024 * 1024)
  const value = Number.isInteger(mb) ? String(mb) : mb.toFixed(1)
  return `${value} MB`
}

function notifyFileTooLarge(fileSize, maxSize) {
  const message = `A imagem selecionada (${formatSize(fileSize)}) excede o limite de ${formatSize(maxSize)}.`

  if (window.appAlert && typeof window.appAlert.toastError === 'function') {
    window.appAlert.toastError(message, 'Arquivo muito grande')
    return
  }

  window.alert(message)
}

function bindPackageFormUploadGuard(form) {
  if (form.dataset.packageUploadGuardBound === 'true') return

  const fileInput = form.querySelector(FILE_INPUT_SELECTOR)
  if (!fileInput) return

  const maxFileSize = parseMaxFileSize(form)

  const validate = () => {
    const file = fileInput.files && fileInput.files[0]
    if (!file) return true

    if (file.size <= maxFileSize) return true

    notifyFileTooLarge(file.size, maxFileSize)
    fileInput.value = ''
    fileInput.focus()
    return false
  }

  fileInput.addEventListener('change', () => {
    validate()
  })

  form.addEventListener('submit', (event) => {
    if (validate()) return

    event.preventDefault()
    event.stopImmediatePropagation()
  })

  form.dataset.packageUploadGuardBound = 'true'
}

function bindAllPackageForms() {
  document.querySelectorAll(PACKAGE_FORM_SELECTOR).forEach((form) => {
    bindPackageFormUploadGuard(form)
  })
}

document.addEventListener('turbo:load', bindAllPackageForms)

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindAllPackageForms, { once: true })
} else {
  bindAllPackageForms()
}
